export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2017.78a7c5cb.pdf";